// extracted by mini-css-extract-plugin
export default {"articleFormCard":"FormInputGroup_articleFormCard__GBdRR"};